module.exports = __webpack_public_path__ + "static/img/bg-tr.fc5ec61f.png";